import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { DMarketRuleComponent } from 'src/app/@shared/components/market-rule/d-market-rule/d-market-rule.component';
import { MMarketRuleComponent } from 'src/app/@shared/components/market-rule/m-market-rule/m-market-rule.component';
import { MessageService } from 'src/app/@shared/message/message.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-bookmaker-detail',
  templateUrl: './bookmaker-detail.component.html',
  styleUrls: ['./bookmaker-detail.component.css']
})
export class BookmakerDetailComponent extends BaseClass<any> implements OnInit, OnChanges {

  @Input() data: any;
  @Output() betDt = new EventEmitter();
  @Output() multiMUpdate = new EventEmitter();
  @Output() updateData = new EventEmitter();
  @Output() changeExpo = new EventEmitter();
  @Output() closeBet = new EventEmitter();

  public marketData: any;
  public odds: any;
  public expo: any;
  public nextExpo: any;
  public mmIds: any;
  public token: any;
  public betSlipData: any;
  public id: any = ''

  constructor(public service: WebserviceService,
    protected modalService: BsModalService,
    public _message: MessageService) { super(document) }

  ngOnInit(): void {
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  ngOnChanges() {
    if (this.data) {
      this.marketData = this.data?.marketData;
      this.odds = this.data?.odds;
      this.expo = this.data?.expo;
      this.nextExpo = this.data?.nextExpo;
      this.mmIds = this.data?.mmIds;
      this.token = this.data?.token;
      this.betSlipData = this.data?.betSlipData;
    }
  }

  getTitle(e: any, re: any) {
    e['isSuspend'] = false;
    let status: any = '';

    if ((this.odds[`${e.market_id}`] && this.odds[`${e.market_id}`]?.cRunners[re?.selection_id]?.suspended == 1) || this.marketData?.bet_allow == 0) {
      status = 'suspended';
      re['isSuspend'] = true;
    } else {
      status = '';
      re['isSuspend'] = false;
    }
    re['susStatus'] = status;
    // return status;
  }

  isOpenBetSlip(item: any) {
    if (item.selection_id == this.id) {
      if ((item?.isSuspend == true && this.env.isBetOpenEnv == true)) {
        this.env.isBetOpenEnv = false;
        this.id = '';
        this.closeBet.emit();
      }
    }
    item["isOpen"] = (this.id && this.id) == '' ? false : true;
    // return (this.id && this.id) == '' ? false : true;

  }

  cashOut(e: any, key: any) {
    this.getServices().Get(`${this.env.baseUrl + this.api.cashOut}/${e?.market_id}`).subscribe(
      (res) => {
        if (res.status == true) {
          let ri = '0';
          e.book_maker_odds.forEach((element: any, i: any) => {
            if (element.selection_id == res?.data?.runner) {
              ri = i;
            }
          });

          let oi = '';
          let bet = {};
          bet = this.odds[e?.market_id]?.cRunners[res?.data?.runner];
          oi = (res?.data?.type.includes('l1') || res?.data?.type.includes('b3')) ? '' : (res?.data?.type.includes('l2') || res?.data?.type.includes('b2')) ? '1' : (res?.data?.type.includes('l3') || res?.data?.type.includes('b1')) ? '2' : ''

          this.openBetPlace(e, this.odds[e?.market_id], ri, bet, oi, res?.data?.type, key, res?.data?.bet_amount)

        } else {
          this._message.errmessage(res?.data?.message);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  openBetPlace(item: any, oddsItem: any, i: any, bet: any, oi: any, bkOrLy: any, key: string, stake: any = 0) {
    this.env.isBetOpenEnv = true;
    this.id = item?.book_maker_odds[i]?.selection_id
    this.betDt.emit({ item: item, oddsItem: oddsItem, i: i, bet: bet, oi: oi, bkOrLy: bkOrLy, key: key, stake: stake })
  }

  bsModalRef!: BsModalRef;
  openModalWithComponent(key: any) {
    const initialState: any = { key: key };
    this.bsModalRef = this.modalService.show((this.env.isMobile)?MMarketRuleComponent:DMarketRuleComponent, {
      initialState,
      class: `${this.env.isMobile ? 'modal-xl' : 'modal-full'}`
    });
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  multiMarketUpdate(item: any, key: any) {
    this.multiMUpdate.emit({ item: item, key: key });
  }

  ngAfterContentChecked() {
    this.marketData?.book_maker_odds.forEach((element: any, i: any) => {
      this.getTitle(this.marketData, element)
      this.isOpenBetSlip(element)
    });
  }

}
